function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.76.122A2.649 2.649 0 00.137 2.777a29.45 29.45 0 000 5.677 2.65 2.65 0 002.625 2.655h.12c3.332.119 6.664.12 9.995 0h.004l.13-.01h.074-.004a2.648 2.648 0 002.605-2.643v-.03a73.626 73.626 0 000-5.643A2.651 2.651 0 0013.06.125a106.044 106.044 0 00-10.299 0zM.137 8.454l-.002-.03v.028h.002zM2.79 1.12a105.07 105.07 0 0110.243 0h.02c.913.01 1.64.74 1.634 1.653v.022a72.61 72.61 0 010 5.607v.049a1.633 1.633 0 01-1.623 1.643h-.029l-.2.01c-3.31.118-6.623.118-9.935 0h-.131A1.638 1.638 0 011.135 8.45v-.055l-.004-.025a28.45 28.45 0 010-5.549l.004-.025v-.025A1.635 1.635 0 012.768 1.12h.01z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.145 2.79a.5.5 0 00-.258.438v4.746a.5.5 0 00.768.424l3.773-2.385a.5.5 0 00-.002-.848L6.653 2.804a.5.5 0 00-.508-.014zm.742 1.34l2.336 1.46-2.336 1.477z"
});

function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15.746 11.208",
    xmlns: "http://www.w3.org/2000/svg",
    className: "w-full h-full fill-current"
  }, props), _ref, _ref2);
}

export default SvgYoutube;